import * as React from "react";
import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/styles.css";

import { artCards } from "./ArtEntries";
import "./ArtPage.css";

function ArtPage(){
    const divs = [];
    const columnCount = 4;
    const cardSize = Object.keys(artCards).length;

    for (let i = 0; i < cardSize; i += columnCount) {
        divs.push(<ArtRow key={i} range={[i, i < cardSize ? i + columnCount : cardSize]}/>);
    }
    return(
        <section name="Art Page" className="page-container">
            {divs}
            <div name="bottomSpacer" className="row justify-content-evenly TopSeperator text-center"></div>
        </section>
    );
}
function ArtRow({range}){
    const [index, setIndex] = React.useState(-1);
    
    let sliced = Object.keys(artCards).slice(range[0], range[1])
    let images = []; 

    // Add images from cards to images Array as an object pair or src: image
    // Can expand on this and add rest of the info in artCards
    Object.keys(artCards).map((key)=>{ 
        images.push({ src : artCards[key].image, title : artCards[key].title, description : artCards[key].description }); 
    })
    
    // Set thew image to show current index.
    function onCardClicked(currentIndex){ setIndex(currentIndex); }

    // Just to go over how Lightbox works: We're passing the index of the created ArtCard, so that when it's clicked, it sends it's index up the chain and tells
    // Lightbox to show that image.
    return(
        <div className="row justify-content-evenly TopSeperator text-center">
            {sliced.map((key) =>(
                <ArtCard key={key.toString()} cardProps={artCards[key]} index={Object.keys(artCards).indexOf(key)} clicked={onCardClicked}/>
            ))}

            <Lightbox 
                index={index} 
                slides={images} 
                open={index >= 0} 
                close={() => setIndex(-1)} 
                plugins={[Captions, Zoom]}
            />
        </div>
    );
}

function ArtCard({cardProps, index, clicked}){
    function handleClick(e){ clicked(index); }
    return(
        <div className="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 text-center first-row-col">
            <div className="art-thumbnail-container">
                <a onClick={handleClick}>
                    <picture>
                        <source srcSet={cardProps.desktopThumbnail} type="image/jpeg" media="(min-width: 40em)"/>
                        <source srcSet={cardProps.mobileThumbnail} type="image/jpeg" />
                        <img className="art-thumbnail" src={cardProps.image} title={cardProps.title} alt={cardProps.title}/>
                    </picture>
                </a>
                <div className="overlay"></div>
            </div>
        </div>
    );  
}

export default ArtPage;